var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tag',{attrs:{"type":`${
      !_vm.type ? 'danger' : _vm.type.includes('Nocturna') ? 'secondary' : 'info'
    }`}},[_vm._v("\n    "+_vm._s(_vm.type ? _vm.type : _vm.$t('common_words.no_assignment'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }